/* code start for show only 30 alphabets of produts
  
 
/assets/custom.js  |  instant product-title truncate */
(function () {
  const sel = '.product-card .text-block p'; // the exact title node
  const max = 30;

  function trim(node) {
    const txt = node.textContent.trim();
    if (txt.length > max) node.textContent = txt.slice(0, max) + '…';
  }

  /* 1️⃣  cards already in the initial HTML */
  document.querySelectorAll(sel).forEach(trim);

  /* 2️⃣  cards injected later via JS (quick-view, filters, etc.) */
  new MutationObserver(muts => {
    muts.forEach(m =>
      m.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;                 // skip text nodes
        if (n.matches && n.matches(sel)) return trim(n);
        n.querySelectorAll && n.querySelectorAll(sel).forEach(trim);
      })
    );
  }).observe(document, {childList: true, subtree: true});
})(); 

/* code end for show only 30 alphabets of produts */

 

 

